import { styled } from '@innowise-group/mui-kit';

export const OptionWrapper = styled.span``;
export const OptionSource = styled.span``;
export const OptionDetails = styled.span`
  color: ${({ theme }) => theme.palette.general.darkGrey[40]};
`;
